import { useTheme } from '@material-ui/core/styles';
import { Divider, Typography } from '@material-ui/core';
import React from 'react';

export const ReportSectionTitle = ({ children: title, divider = false, gutterBottom = false }) => {
  const theme = useTheme();

  return (
    <>
      {divider && (
        <Divider style={{ marginTop: theme.spacing(3), marginBottom: theme.spacing(3) }} />
      )}
      <Typography
        variant="h6"
        style={{marginBottom: !!gutterBottom && theme.spacing(3)}}
        gutterBottom={gutterBottom}
      >
        {title}
      </Typography>
    </>
  );
};